'use strict';
import React from 'react';
import BaseComponent from '../shared/base';
import { MemberBadge } from '../../components/common/member-badge/member-badge';
import { CriminalCheckBadge } from '@src/components/common/badges/criminal-record-check-badge/criminal-record-check-badge';
import { GovIdVerifiedBadge } from '@src/components/common/gov-id-verified-badge/gov-id-verified-badge';
import { Avatar } from '@mui/material';
import { Star } from '@mui/icons-material';
import { getLatestMediaUrl } from '@src/utils/getLatestMediaUrl';

class MerchantInfo extends BaseComponent {
    setMediaUrl(merchantUser) {
        return getLatestMediaUrl(merchantUser);
    }

    getAllMerchantAverage() {
        const self = this;

        if (self.props.merchantFeedback) {
            if (
                typeof self.props.merchantFeedback == 'undefined' ||
                typeof self.props.merchantFeedback.itemReviews == 'undefined' ||
                (self.props.merchantFeedback != [] && !self.props.merchantFeedback) ||
                self.props.merchantFeedback.ratingsCount < 1 ||
                self.props.merchantFeedback.itemReviews < 1
            ) {
                return 0;
            }

            const total = self.props.merchantFeedback.itemReviews.reduce(
                (accumulator, { customerRating }) => customerRating + accumulator,
                0
            );
            const average = total / self.props.merchantFeedback.ratingsCount;

            return average.toFixed(1);
        }
        return 0;
    }

    renderRating() {
        const self = this;
        return (
            <div className='store-rating !tw-pt-0 !tw-pb-0'>
                <span className='stars'>
                    <span style={{ width: `${self.getAllMerchantAverage()}%` }} />
                </span>
                <span className='feedback-text'>({`${self.getAllMerchantAverage()}%`} positive feedback)</span>
            </div>
        );
    }

    renderCustomFieldData() {
        const self = this;
        const { customFieldDefinitions } = self.props;

        const htmlElements = [];
        let propertyListing = [];

        // console.log(';customFieldDefinitions.Records', customFieldDefinitions.Records);

        if (customFieldDefinitions && customFieldDefinitions.Records) {
            propertyListing = customFieldDefinitions.Records.filter(r => r.GroupName !== '' || r.GroupName !== null);
        }

        const propertyListingValue = self.props.merchantUser.CustomFields;

        //ARC-10486
        if (propertyListing && propertyListing.length > 0) {
            const propertyInputTypeViewOrder = [
                'image',
                'textfield',
                'dropdown',
                'checkbox',
                'datetime',
                'hyperlink / url',
                'upload'
            ];
            propertyListing = propertyListing.sort(
                (a, b) =>
                    propertyInputTypeViewOrder.indexOf(a.DataInputType.toLowerCase()) -
                    propertyInputTypeViewOrder.indexOf(b.DataInputType.toLowerCase())
            );
        }

        propertyListing.forEach(function(propList, index) {
            let filteredValue = null;

            if (propertyListingValue) {
                filteredValue = propertyListingValue.filter(d => d.Code == propList.Code);
            }

            // if (filteredValue && filteredValue.length > 0 && typeof (filteredValue) != 'undefined') {
            //     var theValue = filteredValue[0];

            //     if (propList.DataInputType.toLowerCase() == 'textfield' && !["user_seller_location", "user_preferred_location"].includes(propList.Name.toLowerCase())) {
            //         htmlElements.push(<p key={index}><span>{theValue.Values[0]}</span></p>);
            //     } else if (propList.DataInputType.toLowerCase() == 'dropdown') {
            //         htmlElements.push(<p key={index}><span>{theValue.Values[0]}</span></p>);
            //     } else if (propList.DataInputType.toLowerCase() == 'checkbox') {
            //         theValue.Values.forEach(function (f, ind) {
            //             htmlElements.push(<p key={index + '-' + ind}><span>{f}</span></p>);
            //         });
            //     } else if (propList.DataInputType.toLowerCase() == 'upload') {
            //         htmlElements.push(<p key={index}><img src="/assets/images/pdf-icon.svg" alt="location-icon.svg" align="absmiddle" />&nbsp;<a target="_blank" href={theValue.Values[0]}><span>Download {theValue.Values[0].substr(0, 24)}&hellip;</span></a></p>);
            //     } else if (propList.DataInputType.toLowerCase() == 'datetime') {
            //         let datetime = moment.unix(theValue.Values[0]).utc().local().format('DD/MM/YYYY hh:mm A');
            //         htmlElements.push(<p key={index}><span>{datetime}</span></p>);
            //     } else if (propList.DataInputType.toLowerCase() == 'image') {
            //         if (theValue.Values[0]) {
            //             htmlElements.push(<div key={index} className="merchant-right-img"><img height="150" align="absmiddle" target="_blank" src={theValue.Values[0]} /></div>);
            //         }
            //     } else if (propList.DataInputType.toLowerCase() == 'hyperlink / url') {
            //         if (theValue.Values[0].indexOf('http') == 0 || theValue.Values[0].indexOf('https') == 0) {
            //             htmlElements.push(<p key={index}><a target="_blank" href={theValue.Values[0]}><span>{theValue.Values[0]}</span></a></p>);
            //         } else {
            //             htmlElements.push(<p key={index}><a target="_blank" href={"https://" + theValue.Values[0]}><span>{theValue.Values[0]}</span></a></p>);
            //         }
            //     }
            // }
        });

        let userLocation = null;
        if (self.props.merchantUser.CustomFields) {
            userLocation = self.props.merchantUser.CustomFields.filter(d => d.Name == 'user_seller_location');
        }

        if (userLocation && userLocation.length > 0 && userLocation[0].Values && userLocation[0].Values.length > 0) {
            htmlElements.push(
                <p key='location'>
                    <img src='/assets/images/location.svg' /> {userLocation[0].Values[0]}
                </p>
            );
        }
        htmlElements.push(<p key='visitor'>{self.props.merchantTotalVisits} Visitors</p>);
        htmlElements.push(<p key='order'>{self.props.merchantUser.TotalSuccessfulOrderCount} Successful orders</p>);
        htmlElements.push(
            <p key='member'>Member since {self.rawFormatDateTime(self.props.merchantUser.DateJoined, 'MMMM/YYYY')}</p>
        );

        return htmlElements;
    }

    render() {
        const self = this;

        return (
            <div className='tw-w-full tw-max-w-[320px] tw-space-y-[8px]'>
                <Avatar
                    alt={self.props.merchantUser.DisplayName}
                    src={self.setMediaUrl(self.props.merchantUser)}
                    className='tw-mt-[4px]'
                />
                <div className='tw-grow tw-flex tw-flex-col tw-justify-center tw-gap-[4px] tw-min-h-[50px]'>
                    <div className=' tw-flex tw-gap-[8px] tw-text-[#333333] tw-text-[16px] tw-font-[700] tw-items-start'>
                        <div>
                            {self.props.merchantUser.BusinessName ? (
                                <div>{self.props.merchantUser.BusinessName}</div>
                            ) : null}
                            <div className='tw-font-medium'>{self.props.merchantUser.DisplayName}</div>
                        </div>
                        {self.props.merchantUser.IsGovIdVerified ? (
                            <GovIdVerifiedBadge className='tw-w-[24px] tw-aspect-square' />
                        ) : null}
                    </div>
                    <div className='tw-space-y-[4px]'>
                        <div className='tw-flex tw-gap-[4px] tw-items-center'>
                            {self.props.merchantUser.IsCriminalRecordVerified ? (
                                <CriminalCheckBadge className='tw-w-[185px]' />
                            ) : null}
                            {self.props.merchantUser.IsMember ? (
                                <MemberBadge className='tw-w-[90px] tw-overflow-d-none tw-rounded-[6px] tw-h-[30px]' />
                            ) : null}
                        </div>
                        {self.props.merchantUser.IsMember && self.props.merchantUser.ShowMembership && (
                            <span className='tw-block tw-text-[14px] tw-text-[#5A5A5A]'>
                                BCAA Member since {self.props.merchantUser.MembershipJoinDate}
                            </span>
                        )}
                        <div className='tw-gap-[4px] tw-flex tw-items-center'>
                            <Star size={16} weight='fill' className='tw-text-yellow-500' />
                            <span className='tw-text-[14px]'>
                                {this.getAllMerchantAverage()} ({self.props.merchantFeedback?.ratingsCount})
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MerchantInfo;
